import { useEffect, useState } from 'react';

export const useIsLoading = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const callback = (e: MessageEvent) => {
      try {
        if (e.data === 'module-ready') {
          setIsLoading(false);
        }
      } catch {
        // Ignore parsing errors for other message types
      }
    };

    window.addEventListener('message', callback);

    return () => window.removeEventListener('message', callback);
  }, []);

  return isLoading;
};
